import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Apple, Stethoscope, Scissors, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const { t } = useLanguage();

  const services = [
    {
      icon: Apple,
      title: t('service1_title'),
      desc: t('service1_desc'),
      image: "https://images.unsplash.com/photo-1757596057470-19d36962705d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxoZWFsdGh5JTIwZm9vZCUyMG51dHJpdGlvbiUyMHNhbGFkJTIwZnJlc2glMjB2ZWdldGFibGVzfGVufDB8fHx8MTc3MTc1NDgzN3ww&ixlib=rb-4.1.0&q=85",
      color: 'bg-emerald-50 text-emerald-600',
    },
    {
      icon: Scissors,
      title: t('service4_title'),
      desc: t('service4_desc'),
      image: "img-01.jpg",
      color: 'bg-rose-50 text-rose-600',
    },
    {
      icon: Stethoscope,
      title: t('service2_title'),
      desc: t('service2_desc'),
      image: "img-02.jfif",
      color: 'bg-blue-50 text-blue-600',
    },
    {
      icon: Scissors,
      title: t('service3_title'),
      desc: t('service3_desc'),
      image: "img-03.jpeg",
      color: 'bg-teal-50 text-teal-600',
    },
  ];

  const [expandedCards, setExpandedCards] = useState({});

  const toggleCard = (index) => {
    setExpandedCards(prev => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <section
      id="services"
      className="section-padding bg-slate-50 py-20"
      data-testid="services-section"
    >
      {/* Increased max-width slightly to accommodate 4 columns comfortably */}
      <div className="max-w-7xl mx-auto px-4">
        
        {/* Section Header */}
   <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className=" text-[#800000] font-semibold text-sm uppercase tracking-wider">
            {t('services_subtitle')}
          </span>
           <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900  p-2">
            {t('services_title')}
          </h2>
        </div>

        {/* Services Grid - Forced to 4 columns on large screens */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {services.map((service, index) => {
            const words = service.desc.split(" ");
            const isLong = words.length > 15; // Shorter preview for 4-column layout
            const preview = words.slice(0, 15).join(" ");
            const isExpanded = expandedCards[index];

            return (
              <div
                key={index}
                className="group bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden border border-slate-100 flex flex-col"
                data-testid={`service-card-${index + 1}`}
              >
                {/* Image & Icon Overlay */}
                <div className="relative aspect-[16/10] overflow-hidden bg-slate-100">
                  <img
                    src={service.image}
                    alt={service.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className={`absolute top-3 left-3 w-8 h-8 ${service.color} rounded-lg shadow-sm flex items-center justify-center`}>
                    <service.icon className="w-4 h-4" />
                  </div>
                </div>

                {/* Content */}
                <div className="p-4 flex flex-col flex-grow">
                  <h3 className=" font-bold text-slate-900 mb-2 group-hover:text-[#800000] transition-colors leading-tight text-xl py-1">
                    {service.title}
                  </h3>
                  
                  <p className="text-slate-600 text-[15px] md:text-xs leading-relaxed flex-grow whitespace-pre-line">
                    {isExpanded ? service.desc : preview}
                    {isLong && (
                      <button
                        onClick={() => toggleCard(index)}
                        className="text-[#800000] font-bold cursor-pointer ml-1 hover:underline"
                      >
                        {isExpanded ? " Less" : "...more"}
                      </button>
                    )}
                  </p>

                  <div className="mt-3 pt-3 border-t border-slate-50">
                    <Link
                     // href="#contact"
                     to='/contact'
                      className="inline-flex items-center gap-1 text-[#800000] font-bold text-[10px] uppercase tracking-wider group/link"
                    >
                      {t('learn_more')}
                      <ArrowRight className="w-3 h-3 group-hover/link:translate-x-1 transition-transform" />
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;